import request from '@/utils/request'

/**
 * 2023年2月9日
 * 获取收货地址
 * */
export function getAllAddress() {
    let url = 'procurement/system/front/enterprise-delivery-addresss/my';

    return request({
        url: url,
        method: 'GET',
    })
}

/**
 * 2023年2月9日
 * 添加收货地址
 * */
export function addEnterpriseAddress(data) {
    let url = 'procurement/system/front/enterprise-delivery-addresss';

    return request({
        url: url,
        method: "POST",
        data: data
    })
}

/**
 * 2023年2月9日
 * 更新收货地址
 * */
export function updateEnterpriseAddress(data) {
    let url = 'procurement/system/front/enterprise-delivery-addresss';

    return request({
        url: url,
        method: "PUT",
        data: data
    })
}

/**
 * 2023年2月9日
 * 删除收货地址
 * */
export function deleteEnterpriseAddress(params) {
    let url = 'procurement/system/front/enterprise-delivery-addresss?id=' + params;

    return request({
        url: url,
        method: "DELETE",
    })
}

/**
 * 查询高德行政区
 * @param keywords
 * @returns {*}
 */
export function getAmap(keywords) {
    let params = {
        key: process.env.VUE_APP_AMAP_KEY,
        keywords: keywords
    };

    return fetch(
        "https://restapi.amap.com/v3/config/district?key=" + params.key
        + "&keywords=" + params.keywords + "&subdistrict=1&extensions=base",
        {
            method: 'get'
        }
    ).then(result => {
        return result.json();
    })
}